import { FC } from 'react';

import { format } from 'bloko/common/trl';

import Pagination, { PaginationProps } from 'src/components/Pagination/index';

interface SeoPaginationProps extends PaginationProps {
    /** URL, относительно которого будут формироваться ссылки пагинации с page параметром **/
    basePath: string;
    /** Если страница не первая, шаблон параметра page после форматирования конкатенируется с basePath **/
    templatePageParam: string;
}

const SeoPagination: FC<SeoPaginationProps> = ({ basePath, templatePageParam, ...paging }) => {
    const getGenericUrl = (pageId: number) => {
        const pageParam = pageId > 0 ? format(templatePageParam, { '{0}': pageId + 1 }) : '';
        return `${basePath}${pageParam}`;
    };
    return <Pagination getGenericPageUrl={getGenericUrl} isSeoPaging {...paging} />;
};

export default SeoPagination;
